<template>
    <div class="layout-reminder-popup layout-reminder-collate" @click.stop="clickReminder">
        <!-- 底部遮罩层 -->
        <div v-if="startCheck && collateExtTime[curKey]" class="layout-overlay"></div>
        
        <!-- 1、浮窗弹框 -->
        <div v-if="collateExtTime[collateKeyArr[0]] && collateExtTime[collateKeyArr[0]] < 0" class="layout-reminder-content">
            <div v-bind:class="{'layout-reminder-collate-bubble-1': CONFIG.platform == 'wechat', 'layout-reminder-collate-bubble-11': CONFIG.platform == 'qq'}"></div>
        </div>

        <!-- 2、标签弹框 -->
        <div v-if="collateExtTime[collateKeyArr[1]] && collateExtTime[collateKeyArr[1]] < 0" class="layout-reminder-content">
            <div class="layout-reminder-collate-label">
                <span>标签备注</span>
            </div>
            <div class="layout-reminder-collate-bubble-2"></div>
        </div>
    </div>
</template>

<script>
import { CONFIG } from '../../modules/config'
export default {
    name: 'ReminderFloat',
    computed: {
        collateExtTime() {
            return this.$store.state.reminder.collateExtTime
        },
        collateKeyArr() {
            return this.$store.state.reminder.collateKeyArr
        }
    },
    data() {
        return {
            CONFIG: CONFIG,
            startCheck: false,
            keyIndex: 0,
            curKey: ''
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            me.initDom();
        }, 20);
        setTimeout(() => {
            me.checkData();
        }, 1000);
    },
    methods: {
        initDom() {
            this.$el.style.width = innerWidth + 'px';
            this.$el.style.height = innerHeight + 'px';
        },
        checkData() {
            var me = this,
                curPath = this.$router.history.current.path;
            if(curPath != '/collate') {
                this.$store.state.reminder.showCollateReminder = false;
                // this.$store.state.reminder.showVersionReminder = true;
                // this.$store.state.reminder.showDownloadReminder = true;
                return;
            }
            this.startCheck = true;
            // this.$store.state.reminder.showVersionReminder = false;
            // this.$store.state.reminder.showDownloadReminder = false;
            console.log('RemindCollate:::::::checkData------', this.curKey, this.collateExtTime)

            this.curKey = this.collateKeyArr[this.keyIndex];
            if(!this.collateExtTime[this.curKey] || this.collateExtTime[this.curKey] == -1) {
                this.$set(this.$store.state.reminder.collateExtTime, this.curKey, -1);
            }else {
                if(this.keyIndex < this.collateKeyArr.length - 1) {
                    this.keyIndex++;
                    this.checkData();
                }else {
                    this.$store.state.reminder.showCollateReminder = false;
                    // this.$store.state.reminder.showVersionReminder = true;
                    this.$store.state.reminder.showDownloadReminder = true;
                }
            }
        },
        clickReminder() {
            if(this.curKey == '') { return; }
            var params = {};
                params['collateExtTime'] = Object.assign({}, this.collateExtTime);
                params['collateExtTime'][this.curKey] = 1;
            console.log('clickReminder', params, this.keyIndex)
            
            var me = this;
            this.$store.dispatch('reminder/udpateExtList', {
                params: params,
                cb: function() {
                    if(me.keyIndex < me.collateKeyArr.length - 1) {
                        me.keyIndex++;
                        me.checkData();
                    }else {
                        me.curKey = '';
                        me.startCheck = false;
                        me.$store.state.reminder.showCollateReminder = false;
                        // me.$store.state.reminder.showVersionReminder = true;
                        me.$store.state.reminder.showDownloadReminder = true;
                    }
                }
            })

        }
    }
}
</script>